const escapeRegExp = text => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/**
 * Wraps a textarea selection in [[ ]] so it becomes a tag — every whole-word
 * occurrence of the selected text, case-insensitively, as the add-statement
 * form has always done. Returns null when nothing should change: the whole
 * text is selected, the selection is only whitespace/punctuation, or it is
 * already bracketed.
 */
export const wrapSelectionInBrackets = (
    value,
    selectionStart,
    selectionEnd
) => {
    const selectedText = value.substring(selectionStart, selectionEnd)
    if (
        (selectionStart === 0 && selectionEnd === value.length) ||
        !/\S/.test(selectedText) ||
        selectedText === ']] ' ||
        selectedText.includes('[[') ||
        selectedText.includes(']]')
    ) {
        return null
    }
    if (
        value.slice(selectionStart - 2, selectionStart) === '[[' &&
        value.slice(selectionEnd, selectionEnd + 2) === ']]'
    ) {
        return null
    }

    const regex = new RegExp(`\\b${escapeRegExp(selectedText)}\\b`, 'gi')
    return value.replace(regex, `[[${selectedText}]]`)
}
